import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { SlidingBanner } from '../../interfaces/SlidingBanner/SlidingBanner';
import { getSlidingBanners } from '../../api/SlidingBanner';
import { sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';
import { SlidingBannersTable } from './SlidingBannersTable';

export const SlidingBannersPage = () => {
  const navigate = useNavigate();

  const [slidingBanners, setSlidingBanners] = useState<SlidingBanner[]>([]);
  const [loading, setLoading] = useState(false);

  const refreshSlidingBanners = () => {
    setLoading(true);
    getSlidingBanners()
      .then((s) => setSlidingBanners(s))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshSlidingBanners();
  }, []);

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <Typography variant='h5' sx={{ ...sharedStyles.pageTitle }}>
        Kayan Yazılar
      </Typography>
      <Waiting open={loading} />
      <Button
        variant='contained'
        startIcon={<AddIcon />}
        onClick={() => navigate('/visual/sliding-banners/new')}
        sx={{ ...sharedStyles.buttonText, mb: 1.5 }}
      >
        Yeni Kayan Yazı
      </Button>
      <SlidingBannersTable slidingBanners={slidingBanners} />
    </Box>
  );
};
